import {Component, OnInit} from '@angular/core';
import {UploadService} from '../../../shared/services/upload.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {OcrUploadService} from '../ocr-upload.service';


@Component({
    selector: 'app-convert-file',
    templateUrl: './convert-file.component.html',
    styleUrls: ['./convert-file.component.scss']
})

export class ConvertFileComponent implements OnInit {

    showLoader = false;
    fileContent: string;


    constructor(private uploadService: OcrUploadService,
                private snackBar: MatSnackBar) {
        this.uploadService.uploadFileSubject.subscribe(fileUploaded => {
            if (fileUploaded['body']!== "") {
                var json = JSON.parse(JSON.stringify(fileUploaded['body']));
                json = json.replace(/(?:\r\n|\r|\n)/gm, "<br />");

                this.fileContent = json;

                this.snackBar.open('Fisier incarcat cu succes', 'Ok', {
                    duration: 4000,
                })
                this.showLoader = false;
            } else {
                this.snackBar.open('A aparut o eroare la incarcare', 'Ok', {
                    duration: 4000,
                })

                this.showLoader = false;
            }
        }, error => {
            this.snackBar.open('A aparut o eroare la incarcare', 'Ok', {
                duration: 4000,
            })

            this.showLoader = false;
        });
    }

    selectedFiles?: FileList;
    currentFile?: File;

    selectFile(event: any): void {
        this.selectedFiles = event.target.files;
    }

    uploadFile() {
        this.showLoader = true;
        this.uploadService.upload(this.selectedFiles, '/uploadOCR');
    }

    ngOnInit() {
    }

}
